import { useCallback, useContext, useEffect } from "react";
import { Form } from "antd";
import { useUpdate } from "ahooks";
import { Context } from "./EditorContext";
import Row from "./Row/Row";
import RowContext from "./Row/RowContext";
import { toRGBA } from "./parser/utils";
import classNames from "classnames";
import CloseButton from "./CloseButton/CloseButton";
import Teaser from "./Teaser/Teaser";

const DefaultCntWrapper = ({ children }) => {
  return <>{children}</>;
};

const SignupFormCntWrapper = ({ children, contentWidth }) => {
  return (
    <div
      style={{
        width: "100%",
        minHeight: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          zIndex: 2,
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          backgroundColor: "rgba(0, 0, 0, .2)",
        }}
      />
      <div style={{ position: "absolute", zIndex: 3,  width: contentWidth || "100%", }}>
        {children}
        <CloseButton />
      </div>
      <iframe
        src="https://www.radicasys.com"
        style={{
          width: "100%",
          height: "100%",
          position: "absolute",
          zIndex: 1,
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          pointerEvents: "none",
        }}
        frameBorder={0}
      />
    </div>
  );
};

const TeaserCntWrapper = () => {
  return <Teaser />;
};

const CNT_WRAPPER_MAPPING = {
  signup_form: SignupFormCntWrapper,
  signup_thankyou: SignupFormCntWrapper,
  signup_teaser: TeaserCntWrapper,
};

export default () => {
  const { state, shareRefs, notifySubscriber, contentAreaRef, hideHeader } =
    useContext(Context);
  const { root } = state;

  const [form] = Form.useForm();

  const update = useUpdate();

  const handleClickWrapper = useCallback(() => {
    if (shareRefs.selectedNode) {
      shareRefs.selectedNode = null;
      if (shareRefs.updateSelectContent) {
        shareRefs.updateSelectContent();
      }
      shareRefs.updateSelectContent = null;
      notifySubscriber("NODE_SELECT");
    }
  }, [shareRefs, notifySubscriber]);

  const {
    paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft,
    marginTop,
    marginBottom,
    marginRight,
    marginLeft,
    contentAreaWidthMode,
    contentAreaWidthPercentage,
    defultFont,
    contentAreaWidth,
    backgroundColor,
    contentAreaBackgroundColor,
    sideContentAlignment,
    sideContentVerticleAlignment,
    sideImage,
    sideImageUrl,
    sideImageSize,
    contentAreaAlignment = "center",
    contentAreaVerticleAlignment = "start",
    shadowColor,
    shadowBlur,
    parser,
  } = root.data;

  useEffect(() => {
    shareRefs.updateRows = update;
    shareRefs.contentForm = form;
  }, [shareRefs, update, form]);

  let contentWidth =
    contentAreaWidthMode === "percentage"
      ? `${contentAreaWidthPercentage || 100}%`
      : contentAreaWidth;

  const rowContent = root.children.map((node, index) => {
    return (
      <RowContext key={node.id}>
        <Row node={node} rowIndex={index} />
      </RowContext>
    );
  });

  let contentEle;
  if (sideImage === "leftImage") {
    contentEle = (
      <>
        <div className={classNames("rip-mm-side-img-wrapper", sideImageSize)}>
          <img
            src={sideImageUrl}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center center",
            }}
          />
        </div>
        <div
          className={classNames("rip-mm-side-cnt-wrapper", sideImageSize)}
          style={{
            paddingTop,
            paddingBottom,
            paddingRight,
            paddingLeft,
            backgroundColor: toRGBA(contentAreaBackgroundColor),
            alignItems: sideContentAlignment,
            justifyContent: sideContentVerticleAlignment,
          }}
        >
          {rowContent}
        </div>
      </>
    );
  } else if (sideImage === "rightImage") {
    contentEle = (
      <>
        <div
          className={classNames("rip-mm-side-cnt-wrapper", sideImageSize)}
          style={{
            paddingTop,
            paddingBottom,
            paddingRight,
            paddingLeft,
            backgroundColor: toRGBA(contentAreaBackgroundColor),
            alignItems: sideContentAlignment,
            justifyContent: sideContentVerticleAlignment,
          }}
        >
          {rowContent}
        </div>
        <div className={classNames("rip-mm-side-img-wrapper", sideImageSize)}>
          <img
            src={sideImageUrl}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center center",
            }}
          />
        </div>
      </>
    );
  } else {
    contentEle = (
      <div
        className={classNames("rip-mm-side-cnt-wrapper")}
        style={{ paddingTop, paddingBottom, paddingRight, paddingLeft }}
      >
        {rowContent}
      </div>
    );
  }

  const contentAreaStyle = {
    minHeight: 400,
    width: "100%",
    marginTop,
    marginBottom,
    marginRight,
    marginLeft,
  };
  if (sideImage) {
    contentAreaStyle.maxWidth = contentWidth;
    if (shadowBlur || shadowColor) {
      contentAreaStyle.boxShadow = `0 0 ${shadowBlur}px ${toRGBA(shadowColor)}`;
    }
  }

  const ContentWrapper = CNT_WRAPPER_MAPPING[parser] || DefaultCntWrapper;

  return (
    <div className={classNames("col-xs-1 content-wrapper", {"hide-header": hideHeader})} onClick={handleClickWrapper} style={{padding: 20}}>
      <ContentWrapper contentWidth={contentWidth}>
        <div
          className="content-container"
          id="content-container"
          style={{
            fontFamily: defultFont || "arial",
            display: "flex",
            minHeight: "100%",
            alignItems: contentAreaVerticleAlignment,
            justifyContent: contentAreaAlignment,
            backgroundColor: parser === "signup_form" || parser === "signup_thankyou" ? "transparent" : toRGBA(backgroundColor),
          }}
        >
          <div ref={contentAreaRef} style={contentAreaStyle}>
            <div
              style={{
                display: "flex",
                width: "100%",
              }}
            >
              {contentEle}
            </div>
          </div>
        </div>
      </ContentWrapper>
    </div>
  );
};
